// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mlm-card-detail-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 5px 8px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text-light, #7a8499);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}
.mlm-card-detail-btn:hover:not(:disabled) {
  color: #00a896;
  border-color: rgba(0, 201, 183, 0.45);
  background: #e6f9f6;
}
.mlm-card-detail-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.mlm-entry-modal .mlm-entry-modal__loading,
.mlm-details-modal .mlm-entry-modal__loading {
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: var(--m-text-light, #7a8499);
}
.mlm-entry-modal .mlm-entry-form,
.mlm-details-modal .mlm-entry-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.mlm-entry-modal .mlm-entry-form__row,
.mlm-details-modal .mlm-entry-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 560px) {
  .mlm-entry-modal .mlm-entry-form__row,
  .mlm-details-modal .mlm-entry-form__row {
    grid-template-columns: 1fr;
  }
}
.mlm-entry-modal .mlm-entry-form__field,
.mlm-details-modal .mlm-entry-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.mlm-entry-modal .mlm-entry-form__readonly,
.mlm-details-modal .mlm-entry-form__readonly {
  font-size: 13px;
  color: var(--m-text, #1a2236);
}
.mlm-entry-modal .mlm-entry-form__readonly strong,
.mlm-details-modal .mlm-entry-form__readonly strong {
  font-weight: 700;
}
.mlm-entry-modal .mlm-entry-form__preview,
.mlm-details-modal .mlm-entry-form__preview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
  padding: 12px;
  background: var(--m-surface-subtle, #f8fafc);
  border-radius: 8px;
  font-size: 12px;
}
.mlm-entry-modal .mlm-entry-form__preview span,
.mlm-details-modal .mlm-entry-form__preview span {
  display: block;
  color: var(--m-text-light, #7a8499);
  margin-bottom: 2px;
}
.mlm-entry-modal .mlm-entry-form__preview strong,
.mlm-details-modal .mlm-entry-form__preview strong {
  font-weight: 600;
  color: var(--m-text, #1a2236);
}
.mlm-entry-modal .mlm-entry-form__error,
.mlm-details-modal .mlm-entry-form__error {
  margin-top: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #c62828;
}
.mlm-entry-modal .mlm-entry-form-divider,
.mlm-details-modal .mlm-entry-form-divider {
  margin: 18px 0 14px;
  padding-top: 16px;
  border-top: 1px solid var(--m-border, #e5e9f0);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--m-text-light, #7a8499);
}

.mlm-details-modal .mlm-details-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding-right: 4px;
}
.mlm-details-modal .mlm-details-modal__header > span {
  flex: 1 1;
  min-width: 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: var(--m-text, #1a2236);
}
.mlm-details-modal .mlm-details-modal__meta {
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light, #7a8499);
  line-height: 1.4;
}
.mlm-details-modal .mlm-details-kpis {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  margin-bottom: 20px;
  border: 1px solid var(--m-border, #eaecf0);
  border-radius: 10px;
  overflow: hidden;
  background: var(--m-card-background-color, #fff);
}
@media (max-width: 520px) {
  .mlm-details-modal .mlm-details-kpis {
    grid-template-columns: 1fr;
  }
}
.mlm-details-modal .mlm-details-kpi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  text-align: center;
}
.mlm-details-modal .mlm-details-kpi:not(:last-child) {
  border-right: 1px solid var(--m-border, #eaecf0);
}
@media (max-width: 520px) {
  .mlm-details-modal .mlm-details-kpi:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid var(--m-border, #eaecf0);
  }
}
.mlm-details-modal .mlm-details-kpi__label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--m-text-light, #7a8499);
  margin-bottom: 8px;
}
.mlm-details-modal .mlm-details-kpi__value {
  display: block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  color: var(--m-text, #1a2236);
  letter-spacing: -0.02em;
}
.mlm-details-modal .mlm-details-kpi__unit {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  color: var(--m-text-light, #7a8499);
}
.mlm-details-modal .mlm-details-kpi--scrap .mlm-details-kpi__value {
  color: #c62828;
}
.mlm-details-modal .mlm-details-section__title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--m-text-light, #7a8499);
  margin-bottom: 10px;
}
.mlm-details-modal .mlm-details-table-wrap {
  border: 1px solid var(--m-border, #eaecf0);
  border-radius: 10px;
  overflow: hidden;
}
.mlm-details-modal .mlm-details-pagination {
  margin-top: 12px;
}
.mlm-details-modal .mlm-details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.mlm-details-modal .mlm-details-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: left;
  padding: 10px 14px;
  background: var(--m-surface-subtle, #f8fafc);
  color: var(--m-text-light, #7a8499);
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid var(--m-border, #eaecf0);
}
.mlm-details-modal .mlm-details-table td {
  padding: 10px 14px;
  color: var(--m-text, #1a2236);
  border-bottom: 1px solid var(--m-border, #f4f6f9);
  vertical-align: middle;
}
.mlm-details-modal .mlm-details-table__num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  width: 88px;
  white-space: nowrap;
}
.mlm-details-modal .mlm-details-table th.mlm-details-table__num {
  text-align: right;
}
.mlm-details-modal .mlm-details-table tbody tr:last-child td {
  border-bottom: none;
}
.mlm-details-modal .mlm-details-table tbody tr.is-active td {
  background: rgba(0, 201, 183, 0.06);
}
.mlm-details-modal .mlm-details-table tbody tr.is-active td:first-child {
  color: #008f80;
  font-weight: 600;
}
.mlm-details-modal .mlm-details-table tbody tr:hover td {
  background: var(--m-surface-subtle, #f8fafc);
}
.mlm-details-modal .mlm-details-table tbody tr.is-active:hover td {
  background: rgba(0, 201, 183, 0.1);
}
.mlm-details-modal .mlm-details-empty {
  padding: 28px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--m-text-light, #7a8499);
  background: var(--m-surface-subtle, #f8fafc);
  border: 1px solid var(--m-border, #eaecf0);
  border-radius: 10px;
}
.mlm-details-modal .mlm-prod-tree-wrap {
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  overflow: hidden;
}
.mlm-details-modal .mlm-prod-tree {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.mlm-details-modal .mlm-prod-tree th {
  text-align: left;
  padding: 10px 14px;
  background: #f4f7fb;
  color: #7a8499;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid #e4ebf3;
}
.mlm-details-modal .mlm-prod-tree td {
  padding: 11px 14px;
  color: #1a2236;
  vertical-align: middle;
  border-bottom: 1px solid #eef2f7;
}
.mlm-details-modal .mlm-prod-tree__num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  width: 88px;
  white-space: nowrap;
}
.mlm-details-modal .mlm-prod-tree th.mlm-prod-tree__num {
  text-align: right;
}
.mlm-details-modal .mlm-prod-tree__group {
  background: #eaf2fb;
  cursor: pointer;
}
.mlm-details-modal .mlm-prod-tree__group td {
  border-bottom-color: #d7e4f2;
}
.mlm-details-modal .mlm-prod-tree__group:hover td {
  background: #e3edf8;
}
.mlm-details-modal .mlm-prod-tree__group.is-active td:first-child .mlm-prod-tree__group-name {
  color: #008f80;
}
.mlm-details-modal .mlm-prod-tree__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-align: left;
  max-width: 100%;
}
.mlm-details-modal .mlm-prod-tree__group-name {
  font-weight: 700;
  color: #1a2236;
}
.mlm-details-modal .mlm-prod-tree__badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: #8b95a8;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid #d7e0ec;
  border-radius: 6px;
  padding: 1px 6px;
  line-height: 1.3;
  white-space: nowrap;
}
.mlm-details-modal .mlm-prod-tree__meta {
  font-size: 12px;
  font-weight: 500;
  color: #8b95a8;
}
.mlm-details-modal .mlm-prod-tree__child {
  background: #fff;
}
.mlm-details-modal .mlm-prod-tree__child td {
  padding-top: 12px;
  padding-bottom: 12px;
}
.mlm-details-modal .mlm-prod-tree__child:hover td {
  background: #fafbfd;
}
.mlm-details-modal .mlm-prod-tree__child-part {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #3a4559;
  font-weight: 500;
}
.mlm-details-modal .mlm-prod-tree__rail {
  width: 2px;
  min-height: 18px;
  margin-top: 2px;
  border-radius: 2px;
  background: #c9d4e3;
  flex-shrink: 0;
}
.mlm-details-modal .mlm-prod-tree__detail {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
}
.mlm-details-modal .mlm-prod-tree__detail strong {
  font-weight: 700;
  color: #1a2236;
}
.mlm-details-modal .mlm-prod-tree__sub {
  flex-basis: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #8b95a8;
}
.mlm-details-modal .mlm-prod-tree__who {
  font-weight: 700;
  color: #1a2236;
}
.mlm-details-modal .mlm-prod-tree__total {
  background: #eaf2fb;
}
.mlm-details-modal .mlm-prod-tree__total td {
  border-top: 1px solid #b8cce3;
  border-bottom: none;
  font-weight: 800;
  color: #1d4ed8;
  padding-top: 12px;
  padding-bottom: 12px;
}
.mlm-details-modal .mlm-prod-tree__total .mlm-prod-tree__num {
  color: #1a2236;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/MachineMonitor/MachineMonitor.modals.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kFACE;AAFJ;AAME;EACE,cAAA;EACA,qCAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;AALJ;;AAWE;;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AAPJ;AAUE;;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAPJ;AAUE;;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAPJ;AASI;EALF;;IAMI,0BAAA;EALJ;AACF;AAQE;;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AALJ;AAQE;;EACE,eAAA;EACA,6BAAA;AALJ;AAOI;;EACE,gBAAA;AAJN;AAQE;;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;AALJ;AAOI;;EACE,cAAA;EACA,mCAAA;EACA,kBAAA;AAJN;AAOI;;EACE,gBAAA;EACA,6BAAA;AAJN;AAQE;;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALJ;AAQE;;EACE,mBAAA;EACA,iBAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;AALJ;;AAUE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAPJ;AASI;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAPN;AAWE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;EACA,qCAAA;EACA,MAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;AAVJ;AAYI;EAVF;IAWI,0BAAA;EATJ;AACF;AAYE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAVJ;AAYI;EACE,gDAAA;AAVN;AAYM;EAHF;IAII,kBAAA;IACA,iDAAA;EATN;AACF;AAYI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;AAVN;AAaI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,uBAAA;AAXN;AAcI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAZN;AAeI;EACE,cAAA;AAbN;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,gBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iDAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,6BAAA;EACA,iDAAA;EACA,sBAAA;AAnBN;AAsBI;EACE,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AApBN;AAuBI;EACE,iBAAA;AArBN;AAwBI;EACE,mBAAA;AAtBN;AAyBI;EACE,mCAAA;AAvBN;AAyBM;EACE,cAAA;EACA,gBAAA;AAvBR;AA2BI;EACE,4CAAA;AAzBN;AA4BI;EACE,kCAAA;AA1BN;AA8BE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,4CAAA;EACA,0CAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AA9BJ;AAgCI;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;AA9BN;AAiCI;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,gCAAA;AA/BN;AAkCI;EACE,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAhCN;AAmCI;EACE,iBAAA;AAjCN;AAoCI;EACE,mBAAA;EACA,eAAA;AAlCN;AAoCM;EACE,4BAAA;AAlCR;AAqCM;EACE,mBAAA;AAnCR;AAsCM;EACE,cAAA;AApCR;AAwCI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAtCN;AAyCI;EACE,gBAAA;EACA,cAAA;AAvCN;AA0CI;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAxCN;AA2CI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAzCN;AA4CI;EACE,gBAAA;AA1CN;AA4CM;EACE,iBAAA;EACA,oBAAA;AA1CR;AA6CM;EACE,mBAAA;AA3CR;AA+CI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AA7CN;AAgDI;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA9CN;AAiDI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA/CN;AAiDM;EACE,gBAAA;EACA,cAAA;AA/CR;AAmDI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjDN;AAoDI;EACE,gBAAA;EACA,cAAA;AAlDN;AAqDI;EACE,mBAAA;AAnDN;AAqDM;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AAnDR;AAsDM;EACE,cAAA;AApDR","sourcesContent":["// Portal modals render outside .machine-live-monitor — keep styles at root scope.\n\n.mlm-card-detail-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 5px 8px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 6px;\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text-light, #7a8499);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    color 0.15s ease,\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    color: #00a896;\n    border-color: rgba(0, 201, 183, 0.45);\n    background: #e6f9f6;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.mlm-entry-modal,\n.mlm-details-modal {\n  .mlm-entry-modal__loading {\n    padding: 24px 0;\n    text-align: center;\n    font-size: 13px;\n    color: var(--m-text-light, #7a8499);\n  }\n\n  .mlm-entry-form {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .mlm-entry-form__row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n\n    @media (max-width: 560px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .mlm-entry-form__field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .mlm-entry-form__readonly {\n    font-size: 13px;\n    color: var(--m-text, #1a2236);\n\n    strong {\n      font-weight: 700;\n    }\n  }\n\n  .mlm-entry-form__preview {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 10px;\n    padding: 12px;\n    background: var(--m-surface-subtle, #f8fafc);\n    border-radius: 8px;\n    font-size: 12px;\n\n    span {\n      display: block;\n      color: var(--m-text-light, #7a8499);\n      margin-bottom: 2px;\n    }\n\n    strong {\n      font-weight: 600;\n      color: var(--m-text, #1a2236);\n    }\n  }\n\n  .mlm-entry-form__error {\n    margin-top: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #c62828;\n  }\n\n  .mlm-entry-form-divider {\n    margin: 18px 0 14px;\n    padding-top: 16px;\n    border-top: 1px solid var(--m-border, #e5e9f0);\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--m-text-light, #7a8499);\n  }\n}\n\n.mlm-details-modal {\n  .mlm-details-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    min-width: 0;\n    padding-right: 4px;\n\n    > span {\n      flex: 1;\n      min-width: 0;\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 20px;\n      color: var(--m-text, #1a2236);\n    }\n  }\n\n  .mlm-details-modal__meta {\n    margin: 0 0 16px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text-light, #7a8499);\n    line-height: 1.4;\n  }\n\n  .mlm-details-kpis {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0;\n    margin-bottom: 20px;\n    border: 1px solid var(--m-border, #eaecf0);\n    border-radius: 10px;\n    overflow: hidden;\n    background: var(--m-card-background-color, #fff);\n\n    @media (max-width: 520px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .mlm-details-kpi {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 16px 12px;\n    text-align: center;\n\n    &:not(:last-child) {\n      border-right: 1px solid var(--m-border, #eaecf0);\n\n      @media (max-width: 520px) {\n        border-right: none;\n        border-bottom: 1px solid var(--m-border, #eaecf0);\n      }\n    }\n\n    &__label {\n      display: block;\n      font-size: 10px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      color: var(--m-text-light, #7a8499);\n      margin-bottom: 8px;\n    }\n\n    &__value {\n      display: block;\n      font-size: 28px;\n      font-weight: 800;\n      line-height: 1;\n      color: var(--m-text, #1a2236);\n      letter-spacing: -0.02em;\n    }\n\n    &__unit {\n      display: block;\n      margin-top: 6px;\n      font-size: 11px;\n      font-weight: 500;\n      color: var(--m-text-light, #7a8499);\n    }\n\n    &--scrap .mlm-details-kpi__value {\n      color: #c62828;\n    }\n  }\n\n  .mlm-details-section__title {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: var(--m-text-light, #7a8499);\n    margin-bottom: 10px;\n  }\n\n  .mlm-details-table-wrap {\n    border: 1px solid var(--m-border, #eaecf0);\n    border-radius: 10px;\n    overflow: hidden;\n  }\n\n  .mlm-details-pagination {\n    margin-top: 12px;\n  }\n\n  .mlm-details-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n\n    th {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      text-align: left;\n      padding: 10px 14px;\n      background: var(--m-surface-subtle, #f8fafc);\n      color: var(--m-text-light, #7a8499);\n      font-weight: 700;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: 0.4px;\n      border-bottom: 1px solid var(--m-border, #eaecf0);\n    }\n\n    td {\n      padding: 10px 14px;\n      color: var(--m-text, #1a2236);\n      border-bottom: 1px solid var(--m-border, #f4f6f9);\n      vertical-align: middle;\n    }\n\n    &__num {\n      text-align: right;\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      width: 88px;\n      white-space: nowrap;\n    }\n\n    th.mlm-details-table__num {\n      text-align: right;\n    }\n\n    tbody tr:last-child td {\n      border-bottom: none;\n    }\n\n    tbody tr.is-active td {\n      background: rgba(0, 201, 183, 0.06);\n\n      &:first-child {\n        color: #008f80;\n        font-weight: 600;\n      }\n    }\n\n    tbody tr:hover td {\n      background: var(--m-surface-subtle, #f8fafc);\n    }\n\n    tbody tr.is-active:hover td {\n      background: rgba(0, 201, 183, 0.1);\n    }\n  }\n\n  .mlm-details-empty {\n    padding: 28px 16px;\n    text-align: center;\n    font-size: 13px;\n    color: var(--m-text-light, #7a8499);\n    background: var(--m-surface-subtle, #f8fafc);\n    border: 1px solid var(--m-border, #eaecf0);\n    border-radius: 10px;\n  }\n\n  .mlm-prod-tree-wrap {\n    border: 1px solid #dbe4f0;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n\n  .mlm-prod-tree {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n\n    th {\n      text-align: left;\n      padding: 10px 14px;\n      background: #f4f7fb;\n      color: #7a8499;\n      font-weight: 700;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: 0.4px;\n      border-bottom: 1px solid #e4ebf3;\n    }\n\n    td {\n      padding: 11px 14px;\n      color: #1a2236;\n      vertical-align: middle;\n      border-bottom: 1px solid #eef2f7;\n    }\n\n    &__num {\n      text-align: right;\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      width: 88px;\n      white-space: nowrap;\n    }\n\n    th.mlm-prod-tree__num {\n      text-align: right;\n    }\n\n    &__group {\n      background: #eaf2fb;\n      cursor: pointer;\n\n      td {\n        border-bottom-color: #d7e4f2;\n      }\n\n      &:hover td {\n        background: #e3edf8;\n      }\n\n      &.is-active td:first-child .mlm-prod-tree__group-name {\n        color: #008f80;\n      }\n    }\n\n    &__toggle {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      border: none;\n      background: none;\n      padding: 0;\n      margin: 0;\n      cursor: pointer;\n      font: inherit;\n      color: inherit;\n      text-align: left;\n      max-width: 100%;\n    }\n\n    &__group-name {\n      font-weight: 700;\n      color: #1a2236;\n    }\n\n    &__badge {\n      display: inline-flex;\n      align-items: center;\n      font-size: 11px;\n      font-weight: 600;\n      color: #8b95a8;\n      background: rgba(255, 255, 255, 0.65);\n      border: 1px solid #d7e0ec;\n      border-radius: 6px;\n      padding: 1px 6px;\n      line-height: 1.3;\n      white-space: nowrap;\n    }\n\n    &__meta {\n      font-size: 12px;\n      font-weight: 500;\n      color: #8b95a8;\n    }\n\n    &__child {\n      background: #fff;\n\n      td {\n        padding-top: 12px;\n        padding-bottom: 12px;\n      }\n\n      &:hover td {\n        background: #fafbfd;\n      }\n    }\n\n    &__child-part {\n      display: flex;\n      align-items: flex-start;\n      gap: 10px;\n      color: #3a4559;\n      font-weight: 500;\n    }\n\n    &__rail {\n      width: 2px;\n      min-height: 18px;\n      margin-top: 2px;\n      border-radius: 2px;\n      background: #c9d4e3;\n      flex-shrink: 0;\n    }\n\n    &__detail {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 6px 8px;\n\n      strong {\n        font-weight: 700;\n        color: #1a2236;\n      }\n    }\n\n    &__sub {\n      flex-basis: 100%;\n      font-size: 12px;\n      font-weight: 500;\n      color: #8b95a8;\n    }\n\n    &__who {\n      font-weight: 700;\n      color: #1a2236;\n    }\n\n    &__total {\n      background: #eaf2fb;\n\n      td {\n        border-top: 1px solid #b8cce3;\n        border-bottom: none;\n        font-weight: 800;\n        color: #1d4ed8;\n        padding-top: 12px;\n        padding-bottom: 12px;\n      }\n\n      .mlm-prod-tree__num {\n        color: #1a2236;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
